const consultation = {
  // HeroSection
  'consultation.hero.title': 'Individual Consultation Booking',
  'consultation.hero.lead': 'Whether you have questions about course selection, tuition, or career prospects, our free individual consultations are here to help. Join us online or in person at our Odaiba campus.',
  'consultation.hero.homeLink': 'Home',
  'consultation.hero.admissionLink': 'Admission Guide',
  'consultation.hero.currentPage': 'Individual Consultation',
  'consultation.hero.imgAlt': 'A faculty member conducting a consultation in a calm, private setting',

  // breadcrumb
  'consultation.breadcrumb.home': 'Home',
  'consultation.breadcrumb.admission': 'Admission Guide',
  'consultation.breadcrumb.current': 'Individual Consultation',

  // ConsultationFeatures
  'consultation.features.label': 'WHAT WE OFFER',
  'consultation.features.title': 'What You Can Discuss',
  'consultation.features.titleEn': 'What You Can Discuss',
  'consultation.features.lead': 'From course selection and tuition to career questions, you are welcome to discuss anything. Choose the format that suits you best — online (video call) or an in-person visit.',
  'consultation.features.freeNote': 'Consultations are completely free of charge and carry no obligation to enrol.',
  'consultation.features.item.0.title': 'Course Selection',
  'consultation.features.item.0.desc': 'From our three courses — Essential, Advanced, and Master — we help you find the best match for your experience level and career goals.',
  'consultation.features.item.1.title': 'Curriculum & Pricing',
  'consultation.features.item.1.desc': 'We walk you through the curriculum, a typical study day, and the full breakdown of tuition fees. No question is too small.',
  'consultation.features.item.2.title': 'Career Guidance',
  'consultation.features.item.2.desc': 'We offer advice on post-graduation career paths and the day-to-day reality of working as a butler, drawing on current industry trends.',
  'consultation.features.item.3.title': 'Campus Tour',
  'consultation.features.item.3.desc': 'You are welcome to tour our classrooms and practical training studio to experience the atmosphere firsthand.',

  // ConsultationForm
  'consultation.form.label': 'BOOKING FORM',
  'consultation.form.title': 'Book a Free Consultation',
  'consultation.form.titleEn': 'Consultation Booking',
  'consultation.form.requiredNote': 'Fields marked as required must be completed. You may indicate up to two preferred time slots.',
  'consultation.form.requiredBadge': 'Required',
  'consultation.form.optionalBadge': 'Optional',
  'consultation.form.altContact': 'You may also reach us by telephone',
  'consultation.form.altContactHours': '(weekdays, 10:00 – 17:00) or by email at',
  'consultation.form.altContactSuffix': '.',
  'consultation.form.nameLabel': 'Full Name',
  'consultation.form.furiganaLabel': 'Name (Phonetic Reading)',
  'consultation.form.emailLabel': 'Email Address',
  'consultation.form.phoneLabel': 'Phone Number',
  'consultation.form.methodLabel': 'Consultation Format',
  'consultation.form.date1Label': 'Preferred Date & Time (1st choice)',
  'consultation.form.date2Label': 'Preferred Date & Time (2nd choice)',
  'consultation.form.contentLabel': 'Topics to Discuss',
  'consultation.form.namePlaceholder': 'e.g. James Smith',
  'consultation.form.furiganaPlaceholder': 'e.g. James Smith (roman)',
  'consultation.form.phonePlaceholder': 'e.g. 090-1234-5678',
  'consultation.form.emailPlaceholder': 'e.g. taro@example.com',
  'consultation.form.date1Placeholder': 'e.g. July 10, 2026 (Fri) 14:00~',
  'consultation.form.date2Placeholder': 'e.g. July 12, 2026 (Sun) 10:00~',
  'consultation.form.contentPlaceholder': 'Please share any questions you would like to cover or the courses you are interested in. Feel free to write freely.',
  'consultation.form.accessLink': 'View access guide',
  'consultation.form.privacyLabel': 'I agree to the',
  'consultation.form.privacyLink': 'Privacy Policy',
  'consultation.form.submitBtn': 'Proceed to Confirmation',

  // Validation messages
  'consultation.form.error.name': 'Full name is required.',
  'consultation.form.error.furigana': 'Phonetic reading is required.',
  'consultation.form.error.emailRequired': 'Email address is required.',
  'consultation.form.error.emailInvalid': 'Please enter a valid email address.',
  'consultation.form.error.phone': 'Phone number is required.',
  'consultation.form.error.method': 'Please select a consultation format.',
  'consultation.form.error.date1': 'A first-choice date and time is required.',
  'consultation.form.error.content': 'Please limit your message to 500 characters.',
  'consultation.form.error.privacy': 'You must agree to the Privacy Policy to proceed.',

  // PostSubmitGuide
  'consultation.post.label': 'AFTER BOOKING',
  'consultation.post.title': 'After Your Booking',
  'consultation.post.titleEn': 'What to Expect',
  'consultation.post.lead': 'Thank you for your booking request. A member of our team will contact you within two business days to confirm a suitable date and time based on your preferences.',
  'consultation.post.step1.num': '1',
  'consultation.post.step1.title': 'Auto-reply Email',
  'consultation.post.step1.desc': 'A confirmation email will be sent automatically to confirm receipt of your booking request.',
  'consultation.post.step2.num': '2',
  'consultation.post.step2.title': 'Schedule Confirmation',
  'consultation.post.step2.desc': 'Within two business days, a staff member will contact you to finalise the date and time.',
  'consultation.post.step3.num': '3',
  'consultation.post.step3.title': 'Consultation',
  'consultation.post.step3.desc': 'Your consultation will take place online or in person, guided by one of our specialist instructors.',
  'consultation.post.urgentNote': 'For urgent enquiries, please call us at',
  'consultation.post.urgentSuffix': '(weekdays, 10:00 – 17:00).',

  // AlternativeContact
  'consultation.altContact.label': 'OTHER WAYS',
  'consultation.altContact.title': 'Other Ways to Book',
  'consultation.altContact.titleEn': 'Alternative Booking Methods',
  'consultation.altContact.lead': 'You are also welcome to book your consultation by telephone or email.',
  'consultation.altContact.phone.title': 'Book by Telephone',
  'consultation.altContact.phone.hours': 'Weekdays, 10:00 – 17:00',
  'consultation.altContact.email.title': 'Book by Email',
  'consultation.altContact.email.note': 'Please feel free to reach out',

  // CTASection
  'consultation.cta.label': 'NEXT STEP',
  'consultation.cta.title': 'Ready to Apply?',
  'consultation.cta.lead': 'If you are ready to enrol, you can submit your application directly via our online form.',
  'consultation.cta.applyBtn': 'Go to Application Form',
  'consultation.cta.note': 'If you would like to experience the academy before booking a consultation, we recommend attending a trial seminar. You can also compare our courses on the courses page.',
  'consultation.cta.seminarBtn': 'View Trial Seminar',
  'consultation.cta.coursesBtn': 'Compare Courses',

  // ConsultationForm — method options
  'consultation.form.method.online.label': 'Online (Video Call)',
  'consultation.form.method.online.desc': 'Join from the comfort of your home. Details of the video platform will be shared after your booking is confirmed.',
  'consultation.form.method.visit.label': 'In-person Visit',
  'consultation.form.method.visit.desc': 'Meet us directly at our classroom in Odaiba, Tokyo.',

  // FAQSection
  'consultation.faq.label': 'FAQ',
  'consultation.faq.title': 'Frequently Asked Questions',
  'consultation.faq.titleEn': 'Frequently Asked Questions',
  'consultation.faq.contactNote': 'For further questions, please use our ',
  'consultation.faq.contactLink': 'contact form',
  'consultation.faq.contactSuffix': '.',
  'consultation.faq.0.question': 'Is the consultation free?',
  'consultation.faq.0.answer': 'Yes. Individual consultations are completely free. We welcome both online (video call) and in-person visits.',
  'consultation.faq.1.question': 'What can I discuss?',
  'consultation.faq.1.answer': 'Anything — course selection, curriculum, tuition, career advice, campus tours, and more. Feel free to bring all your questions.',
  'consultation.faq.2.question': 'What happens after I book?',
  'consultation.faq.2.answer': 'Within two business days of submitting your request, a member of our team will contact you to arrange a suitable date and time.',

  // RelatedPages
  'consultation.related.label': 'LEARN MORE',
  'consultation.related.title': 'Related Pages',
  'consultation.related.titleEn': 'Explore Further',
  'consultation.related.arrowLabel': 'Learn more',
  'consultation.related.item.0.title': 'Admission Guide',
  'consultation.related.item.0.desc': 'Enrolment process and eligibility criteria',
  'consultation.related.item.1.title': 'Course Comparison',
  'consultation.related.item.1.desc': 'Compare all three courses at a glance',
  'consultation.related.item.2.title': 'Trial Seminar',
  'consultation.related.item.2.desc': 'Experience butler etiquette in a one-day session',
  'consultation.related.item.3.title': 'Access',
  'consultation.related.item.3.desc': 'Directions to our Odaiba, Tokyo campus',

  // footer
  'consultation.footer.lastUpdated': 'Last updated: 13 June 2026',
  'consultation.backToTop.ariaLabel': 'Back to top',

  // Confirm page
  'consultation.confirm.breadcrumb.consultation': 'Individual Consultation',
  'consultation.confirm.breadcrumb.current': 'Confirm',
  'consultation.confirm.title': 'Review Your Booking',
  'consultation.confirm.lead': 'Please check the details below. If everything looks correct, click "Submit" to send your booking request.',
  'consultation.confirm.privacyLabel': 'Privacy Policy',
  'consultation.confirm.privacyAgreed': 'Agreed',
  'consultation.confirm.editBtn': 'Go Back & Edit',
  'consultation.confirm.submitBtn': 'Submit',
  'consultation.confirm.submitting': 'Submitting...',
  'consultation.confirm.errorDefault': 'Submission failed. Please try again or contact us by telephone at 03-6824-4086.',
  'consultation.confirm.errorNetwork': 'A network error occurred. Please check your internet connection and try again.',
  'consultation.confirm.fields.name': 'Full Name',
  'consultation.confirm.fields.furigana': 'Name (Phonetic Reading)',
  'consultation.confirm.fields.email': 'Email Address',
  'consultation.confirm.fields.phone': 'Phone Number',
  'consultation.confirm.fields.consultationMethod': 'Consultation Format',
  'consultation.confirm.fields.preferredDate1': 'Preferred Date & Time (1st choice)',
  'consultation.confirm.fields.preferredDate2': 'Preferred Date & Time (2nd choice)',
  'consultation.confirm.fields.content': 'Topics to Discuss',
  'consultation.confirm.fields.online': 'Online (Video Call)',
  'consultation.confirm.fields.visit': 'In-person visit (Odaiba, Tokyo)',
  'consultation.confirm.fields.empty': '(Not provided)',

  // Complete page
  'consultation.complete.title': 'Thank You for Your Booking Request',
  'consultation.complete.p1': 'A confirmation email has been sent to the address you provided.',
  'consultation.complete.p2': 'A member of our team will contact you within two business days to finalise the date and time based on your preferences. For urgent enquiries, please call 03-6824-4086 (weekdays, 10:00 – 17:00).',
  'consultation.complete.seminarBtn': 'View Trial Seminar',
  'consultation.complete.homeBtn': 'Return to Home',
};

export default consultation;
